import type { Players, Tournoi } from "../types";

/** Message unique pour le blocage « tournoi femmes ». */
export const WOMEN_ONLY_BLOCK_MESSAGE =
  "Ce tournoi est réservé aux joueuses. La licence saisie correspond à un joueur.";

export function isMaleLicence(sexe: string | undefined): boolean {
  return (sexe ?? "").trim().toUpperCase() === "M";
}

/**
 * True si le tournoi est réservé aux femmes et que la licence est masculine.
 */
export function isBlockedByWomenOnlyTournoi(
  tournoi: Pick<Tournoi, "womenOnly"> | null | undefined,
  player: Pick<Players, "sexe"> | null | undefined
): boolean {
  return Boolean(tournoi?.womenOnly) && isMaleLicence(player?.sexe);
}
